/**
 * Created by efowler on 4/1/14.
 */
'use strict';

frontendApp.factory('InviteService', ['$rootScope', '$resource', '$timeout', '$q', 'ConfigService', 'ResourceWrapperService', 'TokenService', 'HttpService', 'NotificationService', 'StateService', function ($rootScope, $resource, $timeout, $q, ConfigService, ResourceWrapperService, TokenService, HttpService, NotificationService, StateService) {

  var _service = {
    invites: []
  };

  var RawInvite = $resource(ConfigService.getServerBaseUrlForResource() + '/invite/:id/project/:projectId',
    {'id': '@id', 'projectId': '@projectId'},
    {'update': {method: 'PUT'}});

  var Invite = ResourceWrapperService.WrapActions(RawInvite);

  _service.findOne = function (id, collectionId, projectId, resourceId, callback) {
    return Invite.get({id: id, projectId: projectId}, function (invite) {
      if (callback) callback(invite);
    })
  };

  _service.findAll = function (callback) {

    Invite.query({}, function (invites) {
      _service.invites.length = 0;
      angular.forEach(invites, function (invite) {
        _service.invites.push(invite);
      });

      if (callback) callback(invites);
    });

    return _service.invites;
  };

  _service.findByProject = function (project, callback) {

    var deferred = $q.defer();
    var promise = deferred.promise;

    promise.then(function (invites) {
      if (callback) callback(invites);
    });

    HttpService.$http({
      method: 'GET',
      url: ConfigService.getServerBaseUrl() + '/invite/project/' + project.id
    }).success(function (response) {
      if (response) {
        deferred.resolve(response);
      } else {
        deferred.reject(null);
      }
    }).error(function () {
      deferred.reject(null);
    });

    return promise;
  };

  _service.getInviteAsResource = function (invite) {
    return new Invite(angular.copy(invite));
  };

  _service.create = function (projectId, email, role) {
    return new Invite({
      projectId: projectId,
      email: email,
      role: role,
      frontendUrl: ConfigService.getFrontendUrl()
    });
  };

  _service.delete = function (invite, callback, errorCallback) {
    var inviteResource = _service.getInviteAsResource(invite);
    inviteResource.$delete(function (response, deleteResponseHeaders) {
      if (callback) callback(response);
    }, function () {
      NotificationService.addError({
        title: 'Error deleting invite',
        description: "That's embarrassing, please try again later",
        timeout: 5000
      });
      if (errorCallback) errorCallback();
    });
  };

  _service.acceptInvite = function (invite, callback, errorCallback) {
    var inviteResource = _service.getInviteAsResource(invite);
    inviteResource.$update(function (response) {
      if (callback) callback(response);
    }, function () {
      NotificationService.addError({
        title: 'Error deleting invite',
        description: "That's embarrassing, please try again later",
        timeout: 5000
      });
      if (errorCallback) errorCallback();
    });
  };

  _service.save = function (newInvite, callback, errorCallback) {
    return newInvite.$save(function (invite) {

      if (callback) callback(invite);

    }, function (response) {
      if (errorCallback) errorCallback(response.data);
    });
  };

  _service.getInvites = function () {
    return _service.invites;
  };

  $rootScope.$on('FeedService.Invite', function (event, message) {
    var exists = false;
    angular.forEach(_service.invites, function (invite) {
      if (invite.id == message.id) {
        exists = true;

      }
    });
    if (!exists)
      _service.invites.push(message);
  });

  $rootScope.$on('FeedService.Uninvite', function (event, message) {
    angular.forEach(_service.invites, function (invite) {
      if (invite.id == message.id)
        _service.invites.pop(invite);
    });
  });

  $rootScope.$on(EVENTS.LOGIN_CONFIRMED, function () {
    _service.findAll()
  });

  return _service;

}]);
